import { routerMiddleware } from 'connected-react-router'
import { applyMiddleware, compose, createStore } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import { PersistConfig } from 'redux-persist/es/types'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'
import { appReducer } from './appReducer'
import { sagaManager } from './sagaManager'

const persistConfig = {
  blacklist: ['router', 'loading'],
  key: 'root',
  storage,
}

export function configureStore(initialState: any, history: any) {
  const rootReducer: any = appReducer(history)

  const sagaMiddleware = createSagaMiddleware()

  const composeEnhancer: typeof compose = (window as unknown as IWindow).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const middlewares = [sagaMiddleware, routerMiddleware(history)]
  const enhancers = [applyMiddleware(...middlewares)]

  const persistedReducer = persistReducer(persistConfig, rootReducer)
  // create store with all the middleware
  // @ts-ignore
  const store = createStore(persistedReducer, initialState, composeEnhancer(...enhancers))

  const persistor = persistStore(store)
  // to be able to clear persistor from dev console
  // @ts-ignore
  window.persistor = persistor

  // run sagas
  sagaManager.startSagas(sagaMiddleware)

  // in dev activate HMR
  if (process.env.NODE_ENV === 'development' && module.hot) {
    // HMR reducers
    module.hot.accept('./appReducer', () => {
      const nextReducer = require('./appReducer').appReducer
      store.replaceReducer(nextReducer)
    })
    // HMR sagas (NB! Sagas internal state won't persist)
    module.hot.accept('./sagaManager', () => {
      sagaManager.cancelSagas(store)
      const nextSagaManager = require('./sagaManager').sagaManager
      nextSagaManager.startSagas(sagaMiddleware)
    })
  }

  return { store, persistor }
}
